<template>
  <section class="section_2">
    <div class="Part2">
      <div class="row gx-lg-5">
        <div v-if="font_type == 1" class="col-lg-6">
          <div class="mb-4 mb-lg-5">
            <h1 class="mtext text-start">WHY SHWE MAW KUN</h1>
            <h5 class="mtext2 bold text-start">
              Education is important for everyone
            </h5>
          </div>
          <p style="text-align: justify">
            Maw Kun International Education Group, registered as Shwe Maw Kun
            Private School with the Ministry of Education, Myanmar, is one of
            Myanmar's pioneering English–Myanmar bilingual schools. Established
            in January 2015, the school was founded with the vision of providing
            high-quality, accessible, and affordable bilingual education through
            a distinctive dual-curriculum pathway that integrates the Myanmar
            National Curriculum with internationally recognised programmes. Shwe
            Maw Kun provides a safe, innovative, and nurturing learning
            environment where every pupil is empowered to develop confidence,
            competence, and character.
            <br />
            <br />
            From Premium Pre-School (Early Years) to Primary, Middle and High
            School Education, the school offers a holistic educational
            experience enriched by Cambridge English, Pearson Edexcel (UK),
            Singapore Mathematics, Coding, foreign languages, leadership,
            character education, mindfulness, entrepreneurship, a wide range of
            co-curricular and extracurricular activities, and enrichment
            programmes. Committed to academic excellence and whole-child
            development, Shwe Maw Kun equips learners with the knowledge,
            skills, values, and global perspectives needed to thrive in an
            ever-changing world and become ethical, compassionate, and socially
            responsible global citizens.
            <br />
            <br />
            High-Quality, Affordable Bilingual Education for a Brighter Future.
          </p>
        </div>
        <div v-if="font_type == 2" class="col-lg-6">
          <h3
            style="line-height: 1.6; font-weight: bold"
            class="mtext size-2 mb-5 text-start mm-title"
          >
            <span style="white-space: nowrap"
              >ရွှေမော်ကွန်း ပညာရေး မိသားစုမှ</span
            >
            <span style="white-space: nowrap">ကြိုဆိုပါတယ်</span>
          </h3>
          <!--            <h5 class="mtext2 bold mb-5 text-start"> WE'RE MAKING EVERY-->
          <!--CHILD'S WORLD BETTER</h5>-->
          <p
            style="
              text-align: justify;
              line-height: 30px;

              font-weight: bold;
            "
            class="text-start"
          >
            ပညာရေးသည် လူတိုင်းအတွက် အရေးကြီးပါသည်။
          </p>
          <p style="text-align: justify; line-height: 30px; text-indent: 3em">
            မြန်မာနိုင်ငံ ပညာရေးဝန်ကြီးဌာနတွင် "ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်း"
            အဖြစ် မှတ်ပုံတင်ထားသော Maw Kun International Education Group သည်
            မြန်မာအမျိုးသားသင်ရိုးညွှန်းတမ်းကို အခြေခံ၍
            ထပ်ဆောင်းဘာသာရပ်များအဖြစ် နိုင်ငံတကာသင်ရိုးများမှ အင်္ဂလိပ်စာ၊
            သင်္ချာ၊ သိပ္ပံ၊ ကွန်ပျူတာဘာသာရပ်များနှင့် AI နည်းပညာကို
            ပေါင်းစပ်သင်ကြားပေးသည့် ကျောင်းတစ်ကျောင်းဖြစ်ပါသည်။
          </p>
          <p style="text-align: justify; line-height: 30px; text-indent: 3em">
            ၂၀၁၅ ခုနှစ်၊ ဇန်နဝါရီလတွင် စတင်တည်ထောင်ခဲ့ပြီး
            မြန်မာအမျိုးသားသင်ရိုးညွှန်းတမ်း အပြင် နိုင်ငံတကာအသိအမှတ်ပြု
            ပညာရေးကို ထပ်ဆောင်းသင်ကြားပေးကာ အရည်အသွေးမြင့်မားပြီး သင့်တင့်သည့်
            ကျောင်းလခနှုန်းထားဖြင့် မြန်မာ၊ အင်္ဂလိပ်ဘာသာစကားနှစ်မျိုးဖြင့်
            ဘက်စုံပညာရေးကို ပံ့ပိုးပေးရန် ရည်ရွယ်ပါသည်။ ရွှေမော်ကွန်း
            ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူတိုင်း မိမိကိုယ်ကို
            ယုံကြည်မှု၊ စွမ်းဆောင်ရည်နှင့် ကိုယ်ကျင့်တရားကောင်းမွန်မှုတို့ကို
            တိုးတက်ဖွံ့ဖြိုးလာစေရန် လုံခြုံစိတ်ချရပြီး ဆန်းသစ်သော
            သင်ယူမှုအခွင့်အလမ်းများနှင့် အားပေးကူညီမှုများ ရရှိနိုင်သည့်
            ပတ်ဝန်းကျင်ကို ဖန်တီးပေးထားပါသည်။
          </p>
          <p
            style="
              text-align: justify;
              line-height: 1.8;
              text-indent: 3em;
              word-break: break-word;
              overflow-wrap: break-word;
            "
          >
            အဆင့်မြင့်မူကြိုပညာရေး (Early Years) မှစ၍ မူလတန်း၊ အလယ်တန်းနှင့်
            အထက်တန်းပညာရေးအထိ ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းသည် ကျောင်းသား၊
            ကျောင်းသူများအတွက် ဘက်စုံပညာရေးအတွေ့အကြုံကို ပေးအပ်လျက်ရှိပါသည်။
            သင်ယူမှုအစီအစဉ်များတွင် Cambridge English၊ Pearson Edexcel (UK)၊
            Singapore Mathematics နှင့် Coding တို့အပြင်
            နိုင်ငံခြားဘာသာစကားများ၊ ခေါင်းဆောင်မှုဖွံ့ဖြိုးရေး (Leadership
            Development)၊ စာရိတ္တပညာပေးခြင်း (Character Education)၊
            သတိပဋ္ဌာန်နှင့် စိတ်တည်ငြိမ်မှု (Mindfulness)၊ စွန့်ဦးတီထွင်မှုနှင့်
            စီးပွားရေးစွမ်းဆောင်ရည် ဖွံ့ဖြိုးရေး (Entrepreneurship) တို့ကိုလည်း
            ထည့်သွင်းသင်ကြားပေးထားပါသည်။ ထို့အပြင် သင်ရိုးနှင့်တွဲဖက်သင်ယူသည့်
            ဘာသာရပ်များ (Co-curricular Subjects or Activities)၊ သင်ရိုးပြင်ပ
            လှုပ်ရှားမှုများ (Extracurricular Activities) နှင့် ဖြည့်စွက်
            သင်ယူမှုအစီအစဉ် (Enrichment Programmes) များကိုလည်း
            စီစဉ်ပေးထားပါသည်။
          </p>
          <p style="text-align: justify; line-height: 30px; text-indent: 3em">
            ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းသည် ပညာရပ်ဆိုင်ရာ ထူးချွန်မှုနှင့်
            ကလေးတစ်ဦးချင်းစီ၏ ဘက်စုံဖွံ့ဖြိုးတိုးတက်မှုကို အလေးထားပြီး၊
            အစဉ်အမြဲပြောင်းလဲတိုးတက်နေသော ကမ္ဘာကြီးတွင် အောင်မြင်စွာ
            ရပ်တည်နိုင်ရန် လိုအပ်သည့် အသိပညာ၊ ကျွမ်းကျင်မှု၊
            တန်ဖိုးထားမှုများနှင့် နိုင်ငံတကာအမြင်များကို ကျောင်းသား၊
            ကျောင်းသူများ ရရှိစေရန် ပျိုးထောင်ပေးလျက်ရှိပါသည်။ ထို့အပြင်
            ကိုယ်ကျင့်တရားကောင်းမွန်ပြီး အခြားသူများအပေါ် စာနာနားလည်တတ် ကာ
            လူမှုအသိုင်းအဝိုင်းအပေါ် တာဝန်ယူတတ်သော ကမ္ဘာ့နိုင်ငံသားကောင်းများ
            ဖြစ်လာစေရန်လည်း အလေးထားဆောင်ရွက်လျက် ရှိပါသည်။
          </p>
        </div>
        <div class="col-lg-6 d-flex align-items-center">
          <div class="intro mx-auto">
            <video style="width: 100%" controls>
              <source
                src="@/assets/videos/ShweMawKunAchievement.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    font_type() {
      return this.$store.state.font_type;
    },
  },
};
</script>

<style lang="scss" scoped>
.mm-title {
  font-family: "Noto Sans Myanmar", "Golos Text", sans-serif;
  text-align: left !important;
}
</style>
